import React, { useEffect, useState } from "react";
import redirectTo from "../../../utils/redirectTo";
import DonationsCard from "./donationCard/DonationCard";
import { sendMetrics } from "../../../utils/misc";
import Link from "next/link";
import styles from "./donations.module.scss";
import { inject, observer } from "mobx-react";
import Image from "next/image";
import CustomCarousel from "../../ui/customCarousel/CustomCarousel";
import BlockContainer from "../../mainPageBlocks/blockContainer";
import MyButton from "../../myButton";

const Donations = (props) => {
  const { donationStore } = props;

  const [donations, setDonations] = useState([]);
  const [loader, setLoader] = useState(true);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1920 },
      items: 3,
      slidesToSlide: 3,
      partialVisibilityGutter: 17,
    },
    desktop: {
      breakpoint: { max: 1919, min: 1440 },
      items: 3,
      slidesToSlide: 3,
      partialVisibilityGutter: 15,
    },
    laptop: {
      breakpoint: { max: 1439, min: 1200 },
      items: 3,
      slidesToSlide: 3,
      partialVisibilityGutter: 15,
    },
    tablet: {
      breakpoint: { max: 1199, min: 768 },
      items: 2,
      slidesToSlide: 2,
      partialVisibilityGutter: 85,
    },
    mobile: {
      breakpoint: { max: 768, min: 360 },
      items: 1,
      slidesToSlide: 1,
      partialVisibilityGutter: 65,
    },
  };

  const getDonations = () => {
    setLoader(true);
    donationStore
      .load(window.screen.availWidth > 1919 ? 9 : 7)
      .then((data) => {
        setDonations(data.records);
        setLoader(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getDonations();
  }, []);

  return (
    <div className={styles.ProfileMainPage_Bottom}>
      <div className={loader ? styles.Show : styles.ShowHidden}></div>
      <div className={!loader ? styles.ContentVisible : styles.Content}>
        <div className={styles.ProfileMainPage_Bottom_Header}>
          <div className={styles.ProfileMainPage_Bottom_Title}>
            <span
              className={styles.BlockTitle}
              onClick={() => {
                sendMetrics("all_donations");
              }}
            >
              Мои донации
            </span>

            <Link href={"/profile/donations"}>
              <div className={styles.BonusLinkAndArrow}>
                <a className={styles.BonusesLink}>Смотреть все</a>
                <svg width="11" height="18" viewBox="0 0 11 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7.58597 9.00003L0.292969 1.70703L1.70697 0.29303L10.414 9.00003L1.70697 17.707L0.292969 16.293L7.58597 9.00003Z" fill="#535356"/>
                </svg>
              </div>
            </Link>
          </div>

          <Link href={"/profile/add_donation"}>
            <span
              className={styles.AddDonationSpan}
              onClick={() => {
                sendMetrics("to_add_donation_from_profile");
              }}
            >
              Добавить донацию
            </span>
          </Link>
        </div>
        <div className={styles.ProfileMainPage_Bottom_Body}>
          {donations?.length > 0 && (
            <Link href={"/profile/add_donation/"}>
              <div
                className={styles.ProfileMainPage_Bottom_Body_New}
                onClick={() => {
                  sendMetrics("to_add_donation_from_profile");
                }}
              >
                <h5 className={styles.ProfileMainPage_Bottom_Body_New_Title}>
                  Добавить донацию
                </h5>
                <MyButton
                  text={"Загрузить справку"}
                  width={"225px"}
                  containerWidth={"225px"}
                />
                <p className={styles.ProfileMainPage_Bottom_Body_New_Text}>
                  Загрузите одну или несколько донаций, чтобы получить доступ к
                  специальным предложениям и бонусам
                </p>
              </div>
            </Link>
          )}

          {donations &&
            donations.map((item) => {
              return (
                <DonationsCard
                  key={item.id}
                  donation={item.data}
                  enableNotViewed
                />
              );
            })}
        </div>
        {donations?.length === 0 && (
          <div
            className={styles.ProfileMainPage_Bottom_Null}
            onClick={() => {
              redirectTo("/profile/add_donation/");
            }}
          >
            <h5 className={styles.ProfileMainPage_Bottom_Body_New_Title}>
              Добавить донацию
            </h5>
            <MyButton
              text={"Загрузить справку"}
              width={"225px"}
              containerWidth={"225px"}
            />
            <p className={styles.ProfileMainPage_Bottom_Body_New_Text}>
              Загрузите одну или несколько донаций, чтобы получить доступ к
              специальным предложениям и бонусам
            </p>
          </div>
        )}
        <div className={styles.ProfileMainPage_Bottom_Mobile}>
          <BlockContainer marginBottom={"0px"} page={"new-lk"}>
            <CustomCarousel
              removeArrowOnDeviceType={["mobile"]}
              swipeable={true}
              draggable={false}
              minimumTouchDrag={70}
              responsive={responsive}
              infinite
              partialVisible={true}
              containerStyle={{ marginLeft: "0" }}
            >
              {donations.map((item) => {
                return (
                  <DonationsCard
                    key={item.id}
                    donation={item.data}
                    enableNotViewed
                  />
                );
              })}
            </CustomCarousel>
          </BlockContainer>
          {/* <Carusel donations={donations} /> */}
        </div>
      </div>
    </div>
  );
};

export default inject("donationStore")(observer(Donations));
